module.exports = __webpack_public_path__ + "img/welcome.30b63204.png";